<template>
  <div>
    <div id="dropdown" />
    <div class="md:flex md:flex-col">
      <div class="md:flex md:flex-col md:h-screen">
        <div class="md:flex md:flex-shrink-0">
          <div class="flex items-center justify-between px-6 py-4 bg-white md:flex-shrink-0 md:justify-center md:w-56">
            <Link class="mt-1" href="/">
              <logo class="fill-white" width="120" height="28" />
            </Link>
            <dropdown class="md:hidden" placement="bottom-end">
              <template #default>
                <svg class="w-6 h-6 fill-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
              </template>
              <template #dropdown>
                <div class="mt-2 px-8 py-4 bg-gray-800 rounded shadow-lg">
                  <main-menu :auth="auth" />
                </div>
              </template>
            </dropdown>
          </div>
          <div class="md:text-md flex items-center justify-between p-4 w-full text-sm bg-white border-b md:px-12 md:py-0">
            <div>
              <div class="mr-4 mt-1 text-gray-600 font-medium">{{ auth.user.account.name }}</div>
            </div>
            <div class="flex justify-end">
              <div class="flex">              
                <div class="p-4 mt-2 mr-8 hidden lg:block">
                  <div class="flex items-center">
                    <div class="mr-4 flex flex-col items-center">
                      <i v-if="thirtyYearChange < 0" class="fas fa-arrow-down text-green-600 text-3xl"></i>
                      <i v-else class="fas fa-arrow-up text-red-600 text-3xl"></i>
                      <div :class="['text-sm text-center', thirtyYearChange < 0 ? 'text-green-600' : 'text-red-600']">
                        {{ formattedThirtyYearChange }}
                      </div>
                    </div>
                    <div class="flex flex-col">
                      <span class="text-sm font-semibold text-gray-400">30 Year Fixed</span>
                      <h1 class="text-3xl font-bold">{{ formattedThirtyYearRate }}</h1>
                    </div>
                  </div>
                </div>
                <div class="p-4 space-x-2 mt-2 mr-8 hidden lg:block">
                  <div class="flex items-center">
                    <div class="mr-4 flex flex-col items-center">
                      <i v-if="fifteenYearChange < 0" class="fas fa-arrow-down text-green-600 text-3xl"></i>
                      <i v-else class="fas fa-arrow-up text-red-600 text-3xl"></i>
                      <div :class="['text-sm text-center', fifteenYearChange < 0 ? 'text-green-600' : 'text-red-600']">
                        {{ formattedFifteenYearChange }}
                      </div>
                    </div>
                    <div>
                      <span class="text-sm font-semibold text-gray-400">15 Year Fixed</span>
                      <h1 class="text-3xl font-bold">{{ formattedFifteenYearRate }}</h1>
                    </div>
                  </div>
                </div>
                <div class="p-4 space-x-2 mt-2 mr-8 hidden lg:block">
                  <div class="flex items-center">
                    <div class="mr-4 flex flex-col items-center">
                      <i v-if="mbsChange > 0" class="fas fa-arrow-up text-green-600 text-3xl"></i>
                      <i v-else class="fas fa-arrow-down text-red-600 text-3xl"></i>
                      <div :class="['text-sm text-center', mbsChange > 0 ? 'text-green-600' : 'text-red-600']">
                        {{ formattedMbsChange }}
                      </div>
                    </div>
                    <div>
                      <span class="text-sm font-semibold text-gray-400">MBS Price</span>
                      <h1 class="text-3xl font-bold">{{ formattedMbsPrice }}</h1>
                    </div>
                  </div>
                </div>
                <div class="p-4 space-x-2 mt-2 mr-8 hidden lg:block">
                  <div class="flex items-center">
                    <div class="mr-4 flex flex-col items-center">
                      <i v-if="tenYearTreasuryChange < 0" class="fas fa-arrow-down text-green-600 text-3xl"></i>
                      <i v-else class="fas fa-arrow-up text-red-600 text-4xl"></i>
                      <div :class="['text-sm text-center', tenYearTreasuryChange < 0 ? 'text-green-600' : 'text-red-600']">
                        {{ formattedTenYearTreasuryChange }}
                      </div>
                    </div>
                    <div>
                      <span class="text-sm font-semibold text-gray-400">10Y Treasury</span>
                      <h1 class="text-3xl font-bold">{{ formattedTenYearTreasury }}</h1>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mr-4 flex items-center">
                <div v-if="auth.user.active" class="flex md:text-right text-xl text-center">
                  <button class="text-red-600 px-2 py-2 hover:underline" tabindex="-1" type="button" @click="turnOff(auth.user.id)">
                    <i class="fas fa-power-off ml-2 text-green-500" />
                  </button>
                </div>
                <div v-else class="flex md:text-right text-xl text-center">
                  <button class="text-red-600 px-2 py-2 hover:underline" tabindex="-1" type="button" @click="turnOn(auth.user.id)">
                    <i class="fas fa-power-off ml-2 text-red-500" />
                  </button>
                </div>
              </div>       
              <dropdown class="mt-1" placement="bottom-end">
                <template #default>
                    <div class="group flex items-center cursor-pointer select-none">             
                      <div v-if="auth.user" class="flex items-center md:justify-start justify-center">
                      <div>
                        <img v-if="auth.user.photo_path" class="block -my-2 mr-2 w-8 h-8 rounded-full"
                          :src="auth.user.photo_path" />
                      </div>
                    </div>
                    <div class="mr-1 text-gray-700 group-hover:text-indigo-600 focus:text-indigo-600 whitespace-nowrap">
                      <span>{{ auth.user.first_name }}</span>
                      <span class="hidden md:inline">&nbsp;{{ auth.user.last_name }}</span>
                    </div>
                    <icon class="w-5 h-5 fill-gray-700 group-hover:fill-indigo-600 focus:fill-indigo-600" name="cheveron-down" />
                  </div>
                </template>
                <template #dropdown>
                  <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                    <Link class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="`/users/${auth.user.id}/edit`">My Profile</Link>
                    <Link v-if="auth.user.owner" class="block px-6 py-2 hover:text-white hover:bg-indigo-500" href="/users">Manage Users</Link>
                    <Link class="block px-6 py-2 hover:text-white hover:bg-indigo-500" href="/processorDeals">Processor Assignments</Link>
                    <Link v-if="auth.user.owner" class="block px-6 py-2 hover:text-white hover:bg-indigo-500" href="/leads/import">Manage Leads</Link>
                    <Link v-if="auth.user.owner" class="block px-6 py-2 hover:text-white hover:bg-indigo-500" href="/contacts/import">Manage Contacts</Link>
                    <Link class="block px-6 py-2 hover:text-white hover:bg-indigo-500" href="/campaigns">Campaign Templates</Link>
                    <Link class="block px-6 py-2 hover:text-white hover:bg-indigo-500" href="/emailTemplates">Email Templates</Link>
                    <Link class="block px-6 py-2 hover:text-white hover:bg-indigo-500" href="/smsTemplates">SMS Templates</Link>
                    <Link class="block px-6 py-2 w-full text-left hover:text-white hover:bg-indigo-500" href="/logout" method="delete" as="button">Logout</Link>
                  </div>
                </template>
              </dropdown>
            </div>
          </div>
        </div>
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <button v-if="showMenu" class="hidden md:block absolute top-1/2 left-48" @click="toggleMenu()"><i class="fas fa-angle-double-left text-gray-300 text-xl hover:text-indigo-500" /></button>
          <button v-if="!showMenu" class="hidden md:block absolute top-1/2 left-4" @click="toggleMenu()"><i class="fas fa-angle-double-right text-indigo-500 text-xl hover:text-white" /></button>
          <transition
            enter-class="opacity-0 -translate-x-full"
            enter-to-class="opacity-100 translate-x-0"
            leave-active-class="absolute"
            leave-class="opacity-100 translate-x-0"
            leave-to-class="opacity-0 -translate-x-full"
          >
            <main-menu :auth="auth" v-if="showMenu" class="hidden flex-shrink-0 p-12 w-56 bg-gray-600 overflow-y-auto md:block" />
          </transition>
          <div class="px-4 py-8 md:flex-1 md:p-12 md:overflow-y-auto" scroll-region>
            <flash-messages />
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { router, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
// import('@/assets/ringcentral.js')

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Link,
    Logo,
    MainMenu,
  },
  props: {
    auth: Object,
  },
  data() {
    return {
      activeidset: '',
      showMenu: true,
    }
  },
  mounted() {
    const scripts = [
      'https://ringcentral.github.io/ringcentral-embeddable/adapter.js?clientId=q7Hblz76QoGK7MdETn09yA&appServer=https://platform.ringcentral.com&disableInactiveTabCallEvent=1&newAdapterUI=1',
    ]
    scripts.forEach(script => {
      let tag = document.head.querySelector(`[src="${ script }"`)
      if (!tag) {
        tag = document.createElement('script')
        tag.setAttribute('src', script)
        tag.setAttribute('type', 'text/javascript')
        document.head.appendChild(tag)
      }
    })
    window.addEventListener('message', (e) => {
      this.ringcentral(e)
    })
  },
  methods:{
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    turnOff(id) {
      router.put(('/users/deactivate/'+id),{ only: ['users'], preserveScroll: true })
    },
    turnOn(id) {
      router.put(('/users/active/'+id),{ only: ['users'], preserveScroll: true })
    },
    ringcentral(e){
      const data = e.data
      if (data) {
        switch (data.type) {

        // //start sms case
        // case 'rc-message-updated-notify':
        //   // get message from widget event
        //   console.log('rc-message-updated-notify:', data.message)

        //   if(data.message.direction == 'Outbound' && data.message.from.phoneNumber == '+1'+this.auth.user.phone.replace(/-/g, '')){
        //     this.type='text'
        //     this.phone=data.message.to[0].phoneNumber
        //   }
        //   // else if (data.message.direction == 'Inbound' && data.message.to[0].phoneNumber == '+1'+this.auth.user.phone.replace(/-/g, '')){
        //   //   this.type='incoming text'
        //   //   this.phone=data.message.from.phoneNumber
        //   // }

        //   router.post('/notes', {
        //     note: data.message.subject,
        //     type: this.type,
        //     phone: this.phone,
        //   },
        //   { preserveScroll: true })

        //   break
        // default:
        //   break

        // //end sms

        case 'rc-call-init-notify':
        // case 'rc-call-start-notify':
        // get call when user creates a call from dial

          if(data.call.direction == 'Outbound'){
            this.type='called'
            this.note='Outbound Call to: '+data.call.to+' from: '+this.auth.user.phone
            this.phone=data.call.to
          }
          else if (data.call.direction == 'Inbound'){
            this.type='incoming call'
            this.note='Inbound Call from: '+data.call.fromNumber+' to: '+this.auth.user.phone
            this.phone=data.call.fromNumber
          }

          //If blank then set to uknown
          if(this.phone ==='')
          {
            this.phone = 'unknown'
          }

          // if(data.call.telephonyStatus == 'Ringing' && data.call.direction == 'Outbound' && data.call.from.phoneNumber == '+1'+this.auth.user.phone.replace(/-/g, '') || data.call.direction == 'Inbound' && data.call.telephonyStatus == 'Ringing' && data.call.to.phoneNumber == '+1'+this.auth.user.phone.replace(/-/g, ''))
          router.post('/notes', {
          // lead_id: this.lead.id,
          // user_id: this.auth.user.id,
            phone: this.phone,
            note: this.note,
            type: this.type,
          },
          { preserveScroll: true })

          break
        }
      }
    },
  },
  computed: {
    formattedThirtyYearRate() {
      const rate = this.auth?.user?.mortgage_rates?.thirty_year_fixed;
      return rate ? rate.toFixed(3) + '%' : 'TBD';
    },
    formattedFifteenYearRate() {
      const rate = this.auth?.user?.mortgage_rates?.fifteen_year_fixed;
      return rate ? rate.toFixed(3) + '%' : 'TBD';
    },
    formattedMbsPrice() {
      const price = this.auth?.user?.mortgage_rates?.mbs_price;
      return price ? price.toFixed(3) : 'TBD';
    },
    formattedTenYearTreasury() {
      const treasury = this.auth?.user?.mortgage_rates?.ten_year_treasury;
      return treasury ? treasury.toFixed(3) : 'TBD';
    },
    thirtyYearChange() {
      return this.auth?.user?.mortgage_rates?.thirty_year_fixed_change || 0;
    },
    fifteenYearChange() {
      return this.auth?.user?.mortgage_rates?.fifteen_year_fixed_change || 0;
    },
    mbsChange() {
      return this.auth?.user?.mortgage_rates?.mbs_change || 0;
    },
    tenYearTreasuryChange() {
      return this.auth?.user?.mortgage_rates?.ten_year_treasury_change || 0;
    },
    formattedThirtyYearChange() {
      return this.thirtyYearChange ? (this.thirtyYearChange > 0 ? '+' : '') + this.thirtyYearChange.toFixed(3) : '0.000%';
    },
    formattedFifteenYearChange() {
      return this.fifteenYearChange ? (this.fifteenYearChange > 0 ? '+' : '') + this.fifteenYearChange.toFixed(3) : '0.000%';
    },  
    formattedMbsChange() {
      return this.mbsChange ? (this.mbsChange > 0 ? '+' : '') + this.mbsChange.toFixed(3) : '0.000';
    },
    formattedTenYearTreasuryChange() {
      return this.tenYearTreasuryChange ? (this.tenYearTreasuryChange > 0 ? '+' : '') + this.tenYearTreasuryChange.toFixed(3) : '0.000%';
    }
  }
}
</script>
